import axios from "axios";

export enum RoleType {
  ADMIN = "Admin",
  NORMAL = "Normal",
}

export type TSignin = {
  emailOrPhone: string;
  password: string;
};

export const signin = (body: TSignin) => {
  return axios.post("/auth/login", body);
};

export const refreshToken = (refreshToken: string) => {
  return axios.post("/auth/refresh-token", { refreshToken });
};
